import React from 'react'
import { connect } from 'react-redux'

import _ from 'underscore'

import { Entity } from '../app/entity'
import Navigator from '../app/navigator'
import TimeRange from '../app/timeRange'

import { PercentileType } from '../domain/ReportCriteria'
import ActualGraph from './graph/tooltip-graph'
import Snapshot from './snapshot/snapshotModel'
import { ApplicationState } from '../redux/ApplicationState'

interface OwnProps {
    responseType: PercentileType
}

interface StateProps {
    navigator: Navigator
    parameters: { [key: string]: string }
    loading: boolean
    data: any
}

type Props = OwnProps & StateProps

class ExternalCallsGraph extends React.Component<Props> {
    public static defaultProps = {
        loading: false,
        data: null,
    }

    private chart: HTMLDivElement | null

    public componentDidMount() {
        if (!this.chart) {
            return
        }

        jQuery(this.chart).on('eventClicked', (e, event) => {
            this.props.navigator.push(
                { event: event.id, events: _.pluck(event.group, 'id').join(',') },
                'XhprofOrganizationBundle.Application.show',
            )
        })

        jQuery(this.chart).on('rangeSelected', (e, dataSet, nextDataSet) => {
            this.props.navigator.push(Snapshot.fromDataSets(dataSet, nextDataSet).toParameters(), 'XhprofProfilerBundle.Snapshot.show')
        })

        jQuery(this.chart).on('rangeDelesect', e => {
            this.props.navigator.push({ date: null, end: null }, 'XhprofOrganizationBundle.Application.show')
        })
    }

    public render() {
        return (
            <div
                className="external-monitoring-graph"
                ref={element => {
                    this.chart = element
                }}
            >
                <ActualGraph {...this.props} />
            </div>
        )
    }
}

export default connect<StateProps>((globalState: ApplicationState) => {
    const key = TimeRange.fromParameters(globalState.tidewaysContext.route.parameters).getCacheKey()
    const graph = globalState.monitor.graph[key] || new Entity()

    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
        ...graph,
    }
})(ExternalCallsGraph)
